// extracted by css-extract-rspack-plugin
export default {"wrapper":"_6b1cd226"};